<script setup lang="ts">
import { ref, onUnmounted, onBeforeMount } from "vue";
import { useI18n } from "vue-i18n";

import useVideoCallStore from "../../Store";
import useUserStore from "@/Modules/User/Store";

import InfoCircleIcon from "@/Components/Icons/InfoCircle.vue";
import DocumentIcon from "@/Components/Icons/Document.vue";

const { t } = useI18n();
const videoCallStore = useVideoCallStore();
const userStore = useUserStore();

const emit = defineEmits<{
  (event: "clickTranscription"): void;
}>();

const intervalIndex = ref<number>();

const handleClickInfoTranscription = () => {
  if (userStore.getUserIsPatient) {
    emit("clickTranscription");
  }
};

onBeforeMount(() => {
  videoCallStore.updateStartDate(new Date());

  intervalIndex.value = setInterval(() => {
    videoCallStore.updateCurrentDate(new Date());
  }, 1000) as unknown as number;
});

onUnmounted(() => {
  clearInterval(intervalIndex.value);
});
</script>

<template>
  <div class="counter" id="video_call_counter">
    <div
      v-if="videoCallStore.isTranscriptionEnabled"
      class="counter__transcription_card"
      :class="{ 'c-pointer': userStore.getUserIsPatient }"
      @click="handleClickInfoTranscription"
    >
      <DocumentIcon class="mr-2" color="content-high" />

      {{ t("general.chat.videocall.transiction_card") }}

      <InfoCircleIcon class="ml-2" color="content-high" />
    </div>

    <p class="text-left typography-low-xl color-content-inverse">
      {{ videoCallStore.durationStringWithSecs }}
    </p>

    <p class="text-left typography-low-m color-content-inverse">
      {{ t("general.chat.videocall.time_title") }}
    </p>
  </div>
</template>

<style scoped lang="scss">
.counter {
  &__transcription_card {
    @include sp.padding(y, 1);
    @include sp.padding(x, 2);
    @include sp.margin(b, 2);
    @include text.general(low, s);
    @include colors.color(content, high);
    @include radius(s);

    display: flex;
    align-items: center;
    font-weight: 700;
    background-color: rgba(217, 217, 217, 0.55);

    &.c-pointer {
      &:hover {
        @include elevation(m);

        background-color: rgba(217, 217, 217, 1);
      }
    }
  }
}
</style>
